module.exports = __webpack_public_path__ + "static/media/lazarus_square.73040b8a.png";